<h2 mat-dialog-title>
  <span class="groupIcon"><mat-icon>folder</mat-icon></span>
  Select File Manager Folder with Referral AI Automation Template.
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>


 <div class="table-wrapper">
  <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">


    <mat-tab label="Office Drive">

      <mat-tree [dataSource]="dataSourceOffice" [treeControl]="treeControlOffice">


        <mat-tree-node *matTreeNodeDef="let node" [ngClass]="{ 'active': activeNode === node.fileManagerItemID }"
          matTreeNodePadding matTreeNodePaddingIndent="20">

          <div class="folderRow">
            <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility:hidden">
              arrow_drop_down
            </mat-icon>

            <div class="folderName">
              <mat-icon *ngIf="!node.isShared" class="folder" (click)="SelectFolder(node)">
                folder
              </mat-icon>

              <mat-icon *ngIf="node.isShared" class="folder" (click)="SelectFolder(node)">
                folder_shared
              </mat-icon>

              <span (click)="SelectFolder(node)">
                {{node.name}}
              </span>

              <mat-icon class="processed" *ngIf="!node.isFile && node.aiAutomationTemplateID > 0"
                matTooltip="{{node.aiAutomationTemplateName}}">
                assessment
              </mat-icon>

              <mat-icon class="referralFolder" *ngIf="node.isReferralFolder"
               matTooltip="Referral">
                assignment_ind
              </mat-icon>

               <mat-icon class="referralFolder" *ngIf="node.isCoreFolder"
                [matTooltip]="coreModuleName">
                app_registration
              </mat-icon>

               <button *ngIf="commingFrom=='Core'" [disabled]="node.isReferralFolder === true" class="plusIcon" mat-stroked-button 
               color="primary" (click)="openAITemplate(node)">
                Select
              </button>

              <button *ngIf="commingFrom=='Referral Management'" [disabled]="node.isCoreFolder === true" class="plusIcon" mat-stroked-button
                color="primary" (click)="openAITemplate(node)">
                Select
              </button>
            </div>
          </div>

        </mat-tree-node>


        <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
          [ngClass]="{ 'active': activeNode === node.fileManagerItemID }" matTreeNodePadding
          matTreeNodePaddingIndent="20">

          <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">

            <mat-icon id="node-{{node.name}}" (click)="rememberNode($event.currentTarget.id,$event)"
              class="mat-icon-rtl-mirror arrowIcon">

              {{ treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right' }}
            </mat-icon>

            <div class="folderName">

              <mat-icon *ngIf="!node.isShared" class="folder" (click)="SelectFolder(node)">
                folder
              </mat-icon>

              <mat-icon *ngIf="node.isShared" class="folder" (click)="SelectFolder(node)">
                folder_shared
              </mat-icon>

              <span class="flname" (click)="SelectFolder(node)">
                {{node.name}}
              </span>

              <mat-icon class="processed" *ngIf="!node.isFile && node.aiAutomationTemplateID > 0"
                matTooltip="{{node.aiAutomationTemplateName}}">
                assessment
              </mat-icon>

              <mat-icon class="referralFolder" *ngIf="node.isReferralFolder"
                 matTooltip="Referral">
                assignment_ind
              </mat-icon>

                <mat-icon class="referralFolder" *ngIf="node.isCoreFolder"
                 [matTooltip]="coreModuleName">
                 app_registration
               </mat-icon>

              <button *ngIf="commingFrom=='Core'" [disabled]="node.isReferralFolder === true" class="plusIcon" mat-stroked-button 
               color="primary" (click)="openAITemplate(node)">
                Select
              </button>

              <button *ngIf="commingFrom=='Referral Management'" [disabled]="node.isCoreFolder === true" class="plusIcon" mat-stroked-button
                color="primary" (click)="openAITemplate(node)">
                Select
              </button>

            </div>

          </div>

        </mat-tree-node>

      </mat-tree>



    </mat-tab>

     <mat-tab label="My Drive">

      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">


        <mat-tree-node *matTreeNodeDef="let node" [ngClass]="{ 'active': activeNode === node.fileManagerItemID }"
          matTreeNodePadding matTreeNodePaddingIndent="20">

          <div class="folderRow">
            <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility:hidden">
              arrow_drop_down
            </mat-icon>

            <div class="folderName">
              <mat-icon *ngIf="!node.isShared" class="folder" (click)="SelectFolder(node)">
                folder
              </mat-icon>

              <mat-icon *ngIf="node.isShared" class="folder" (click)="SelectFolder(node)">
                folder_shared
              </mat-icon>

              <span (click)="SelectFolder(node)">
                {{node.name}}
              </span>

              <mat-icon class="processed" *ngIf="!node.isFile && node.aiAutomationTemplateID > 0"
                matTooltip="{{node.aiAutomationTemplateName}}">
                assessment
              </mat-icon>

              <mat-icon class="referralFolder" *ngIf="node.isReferralFolder"
                matTooltip="Referral">
                assignment_ind
              </mat-icon>

              <mat-icon class="referralFolder" *ngIf="node.isCoreFolder"
               [matTooltip]="coreModuleName">
                app_registration
              </mat-icon>

              <button *ngIf="commingFrom=='Core'" [disabled]="node.isReferralFolder === true" class="plusIcon" mat-stroked-button 
               color="primary" (click)="openAITemplate(node)">
                Select
              </button>

              <button *ngIf="commingFrom=='Referral Management'" [disabled]="node.isCoreFolder === true" class="plusIcon" mat-stroked-button
                color="primary" (click)="openAITemplate(node)">
                Select
              </button>

            </div>
          </div>

        </mat-tree-node>


        <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
          [ngClass]="{ 'active': activeNode === node.fileManagerItemID }" matTreeNodePadding
          matTreeNodePaddingIndent="20">

          <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">

            <mat-icon id="node-{{node.name}}" (click)="rememberNode($event.currentTarget.id,$event)"
              class="mat-icon-rtl-mirror arrowIcon">

              {{ treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right' }}
            </mat-icon>

            <div class="folderName">

              <mat-icon *ngIf="!node.isShared" class="folder" (click)="SelectFolder(node)">
                folder
              </mat-icon>

              <mat-icon *ngIf="node.isShared" class="folder" (click)="SelectFolder(node)">
                folder_shared
              </mat-icon>

              <span class="flname" (click)="SelectFolder(node)">
                {{node.name}}
              </span>

              <mat-icon class="processed" *ngIf="!node.isFile && node.aiAutomationTemplateID > 0"
                matTooltip="{{node.aiAutomationTemplateName}}">
                assessment
              </mat-icon>

              <mat-icon class="referralFolder" *ngIf="node.isReferralFolder"
               matTooltip="Referral">
                assignment_ind
              </mat-icon>

              <mat-icon class="referralFolder" *ngIf="node.isCoreFolder"
                [matTooltip]="coreModuleName">
                app_registration
              </mat-icon>

              <button *ngIf="commingFrom=='Core'" [disabled]="node.isReferralFolder === true" class="plusIcon" mat-stroked-button 
               color="primary" (click)="openAITemplate(node)">
                Select
              </button>

              <button *ngIf="commingFrom=='Referral Management'" [disabled]="node.isCoreFolder === true" class="plusIcon" mat-stroked-button
                color="primary" (click)="openAITemplate(node)">
                Select
              </button>

            </div>

          </div>

        </mat-tree-node>

      </mat-tree>

    </mat-tab>

  </mat-tab-group>

</div> 

 <!-- <div class="table-wrapper">

   <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
         
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.fileManagerItemID }" *matTreeNodeDef="let node ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
            
              <div class="folderRow">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility:hidden" >
                  arrow_drop_down
                </mat-icon>    
                <div class="folderName">
                  <mat-icon  *ngIf="node.isShared == false" class="folder" (click)="SelectFolder(node)">folder</mat-icon>
                  <mat-icon  *ngIf="node.isShared == true" class="folder" (click)="SelectFolder(node)">folder_shared</mat-icon>
                  <span (click)="SelectFolder(node)">{{node.name}}</span>  
                  <mat-icon class="processed" matTooltip="{{node.aiAutomationTemplateName}}" *ngIf="node.isFile == false && node.aiAutomationTemplateID>0">assessment</mat-icon>
                  <mat-icon class="referralFolder" *ngIf="node.isReferralFolder == true">assignment_ind</mat-icon>
                  <button class="plusIcon" mat-stroked-button color="primary" (click)="openAITemplate(node)">Select</button>
                 
                </div>
              </div>
              
            </mat-tree-node>
            
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.fileManagerItemID }"  *matTreeNodeDef="let node;when: hasChild ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon id="node-{{node.name}}" (click)="rememberNode($event.currentTarget.id,$event)" class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>                
                <div class="folderName">
                  <mat-icon  *ngIf="node.isShared == false" class="folder" (click)="SelectFolder(node)">folder</mat-icon>
                  <mat-icon  *ngIf="node.isShared == true" class="folder" (click)="SelectFolder(node)">folder_shared</mat-icon>
                 
                   <span class="flname" (click)="SelectFolder(node)">{{node.name}}</span>
                   <mat-icon class="processed" matTooltip="{{node.aiAutomationTemplateName}}" *ngIf="node.isFile == false && node.aiAutomationTemplateID>0">assessment</mat-icon>
                   <mat-icon class="referralFolder" *ngIf="node.isReferralFolder == true">assignment_ind</mat-icon>
                   <button class="plusIcon" mat-stroked-button color="primary" (click)="openAITemplate(node)">Select</button>
                   
                  </div>
               
              </div>
              
            </mat-tree-node>
   </mat-tree>

</div> -->




<mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-button color="basic" (click)="close()">Cancel</button>
  <!-- <button mat-flat-button class="calltoaction" type="submit" color="primary"  
    [disabled]="showSaveButton==true" (click)="SetDefaultFodlerForReferral()">
    Save
   <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
   </button> -->
</mat-dialog-actions>